var exports = {
  "iU": "Message.module__message___aUMzdT",
  "Ph": "Message.module__messagePreviewSpacing___aUMzdT",
  "IL": "Message.module__messagePreview___aUMzdT",
  "uK": "Message.module__focusRingAnchor___aUMzdT",
  "J8": "Message.module__messageCompact___aUMzdT",
  "Xo": "Message.module__messageHovered___aUMzdT",
  "L8": "Message.module__messageMentioned___aUMzdT",
  "m6": "Message.module__messageReplying___aUMzdT",
  "O6": "Message.module__messageHighlight___aUMzdT",
  "J": "Message.module__messageSelectRange___aUMzdT",
  "lY": "Message.module__contextMenuActive___aUMzdT",
  "Bc": "Message.module__mobileLayout___aUMzdT",
  "p2": "Message.module__messageLongPress___aUMzdT",
  "Uw": "Message.module__messageGrouped___aUMzdT",
  "kT": "Message.module__messageEditing___aUMzdT",
  "E4": "Message.module__messageSent___aUMzdT",
  "mr": "Message.module__messageSending___aUMzdT",
  "b$": "Message.module__messageFailed___aUMzdT",
  "RZ": "Message.module__failedFooter___aUMzdT",
  "Iu": "Message.module__failedFooterMessage___aUMzdT",
  "bg": "Message.module__failedFooterLabel___aUMzdT",
  "OZ": "Message.module__failedFooterIcon___aUMzdT",
  "dv": "Message.module__failedRetryIcon___aUMzdT",
  "QW": "Message.module__failedRetryButton___aUMzdT",
  "Y_": "Message.module__messageRelocationSelecting___aUMzdT",
  "q5": "Message.module__messageGutterLeft___aUMzdT",
  "ZN": "Message.module__messageGutterRight___aUMzdT",
  "$7": "Message.module__messageAvatar___aUMzdT",
  "CW": "Message.module__messageNoText___aUMzdT",
  "U7": "Message.module__messageContent___aUMzdT",
  "rO": "Message.module__messageAuthorInfo___aUMzdT",
  "xW": "Message.module__jumpHeading___aUMzdT",
  "RO": "Message.module__jumpHeadingButton___aUMzdT",
  "dw": "Message.module__messageAuthorRow___aUMzdT",
  "AY": "Message.module__messageAuthorPart___aUMzdT",
  "x": "Message.module__userTagOffset___aUMzdT",
  "oL": "Message.module__messageTimestamp___aUMzdT",
  "BK": "Message.module__authorDashSeparator___aUMzdT",
  "um": "Message.module__messageUsername___aUMzdT",
  "Lo": "Message.module__messageText___aUMzdT",
  "L5": "Message.module__messageTimestampCompact___aUMzdT",
  "tQ": "Message.module__compactAuthorPrefix___aUMzdT",
  "U6": "Message.module__copyOnly___aUMzdT",
  "Mz": "Message.module__compactInlineContent___aUMzdT",
  "aM": "Message.module__systemMessageContent___aUMzdT",
  "vp": "Message.module__contextMenuUnderline___aUMzdT",
  "aE": "Message.module__messageTimeoutIndicator___aUMzdT",
  "t4": "Message.module__textSeparator___aUMzdT",
  "KL": "Message.module__messageTimestampHover___aUMzdT",
  "jh": "Message.module__messageTimestampCompactHover___aUMzdT",
  "iZ": "Message.module__messageAvatarCompact___aUMzdT",
  "kq": "Message.module__compactContentWrapper___aUMzdT",
  "xv": "Message.module__hoverAction___aUMzdT",
  "kL": "Message.module__container___aUMzdT",
  "tI": "Message.module__repliedMessage___aUMzdT",
  "_T": "Message.module__repliedMessageCompact___aUMzdT",
  "$y": "Message.module__repliedTextPreview___aUMzdT",
  "NL": "Message.module__repliedAvatar___aUMzdT",
  "a3": "Message.module__repliedIconContainer___aUMzdT",
  "Pq": "Message.module__repliedIcon___aUMzdT",
  "EK": "Message.module__repliedUsername___aUMzdT",
  "IQ": "Message.module__repliedItalic___aUMzdT",
  "t": "Message.module__unstyled___aUMzdT",
  "Io": "Message.module__repliedTextContent___aUMzdT",
  "c": "Message.module__systemMessageFollowsSystem___aUMzdT",
  "Hj": "Message.module__systemMessageIconWrapper___aUMzdT",
  "Po": "Message.module__systemMessageIconCompact___aUMzdT",
  "jJ": "Message.module__systemMessageTimestamp___aUMzdT",
  "rc": "Message.module__systemMessageContentWrapper___aUMzdT",
  "V_": "Message.module__systemMessageCompactContent___aUMzdT",
  "Gq": "Message.module__systemMessageIconSvg___aUMzdT",
  "hr": "Message.module__systemMessageLink___aUMzdT",
  "ll": "Message.module__userTagCompact___aUMzdT",
  "O4": "Message.module__editedTimestamp___aUMzdT",
  "k8": "Message.module__editedLabel___aUMzdT",
  "zX": "Message.module__typingContainer___aUMzdT",
  "Y9": "Message.module__typingCluster___aUMzdT",
  "RL": "Message.module__typingIndicator___aUMzdT",
  "Kl": "Message.module__typingAvatarContainer___aUMzdT",
  "tY": "Message.module__typingText___aUMzdT",
  "AZ": "Message.module__typingClusterComposerStatus___aUMzdT",
  "am": "Message.module__compactContentNoPrefix___aUMzdT",
  "Ys": "Message.module__compactBody___aUMzdT",
  "Ac": "Message.module__unknownMessageCompactContent___aUMzdT",
  "qU": "Message.module__unknownMessageWarning___aUMzdT",
  "NG": "Message.module__keyboardFocused___aUMzdT",
  "an": "Message.module__messageClientSystem___aUMzdT",
  "og": "Message.module__systemMessageContainer___aUMzdT",
  "Is": "Message.module__systemMessageIcon___aUMzdT",
  "ry": "Message.module__mediaFocusRing___aUMzdT",
  "xS": "Message.module__systemMessageDismissButton___aUMzdT",
  "Eu": "Message.module__silentMessageIcon___aUMzdT",
};

module.exports = exports;
